var numerics = require('./numerics')
// var CURRENCY = require('../constants/currency')

/**
 * Formats a value for a currency, with number formatting specifc to a locale.
 * We don't convert currency values, but the user's locale might affect the formatting.
 * For example:
 *  { currency: 'EUR', locale: 'en-US' } -> €1,234.55
 *  { currency: 'EUR', locale: 'de-DE' } -> 1.234,55 €
 *  { currency: 'EUR', locale: 'nl-NL' } -> € 1.234,55
 * @param {string|number} value The number to format.
 * @param {string} format The format string expected by %f in __() (eg p:2;nots)
 * @param {object} config Config object
 * @param {string} [config.currency=USD] A currency code (eg USD, CNY, EUR)
 * @returns {string} The formatted currency
 */
function currency(value, format, config) {
  //since the currency does not change based on the locale, we need a default locale
  var formattedVal = numerics.format(
    value,
    Object.assign({}, numerics.getOptions(format), {
      style: 'currency',
      currency: (config && config.currency) || 'USD',
      locale: (config && config.locale) || 'en-US',
      //used currencyDisplay to display currency code
      currencyDisplay: 'code',
    })
  )
  if ((config && config.locale) === 'es-ES') {
    var newFormattedVal
    var patt = new RegExp(/[a-zA-Z]/)
    // if the value contains US$ or CA$ remove those alphabets, as the output of getRawValue for those is NaN
    // which will result in failure of our code handling below
    newFormattedVal = patt.test(formattedVal)
      ? formattedVal.replace(/[a-zA-Z]/g, '')
      : formattedVal
    var currencyRawVal = i18nUtils.getNumberUtils().getRawValue(newFormattedVal)
    // if value is 4 digit, then manually add thousand separator for Spanish locale
    if (currencyRawVal >= 1000 && currencyRawVal <= 9999) {
      formattedVal =
        formattedVal[0] +
        i18nUtils.getNumberUtils().format.thousands +
        formattedVal.substr(1)
    }
  }

  return formattedVal
}

module.exports = currency
